export const ConnectionType = {
  MarketData: 'MarketData',
  Orders: 'Orders',
  RFQ: 'RFQ',
  Balances: 'Balances',
  Transfers: 'Transfers',
} as const;
export type ConnectionType = (typeof ConnectionType)[keyof typeof ConnectionType];
